if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');
        this.initialPreOrder = this.dataset.preOrder;

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';

        // Load per-variant metafield data if available (products with variants only)
        const sectionEl = this.closest('[data-section]');
        const sectionId = sectionEl ? sectionEl.dataset.section : null;
        const variantsScript = sectionId ? document.getElementById(`ProductVariants-${sectionId}`) : null;
        this.variants = variantsScript ? JSON.parse(variantsScript.textContent) : [];

        // Set initial button label
        const initialId = this.variantIdInput.value;
        this.currentVariant = this.variants.find((v) => v.id == initialId) || null;
        this.updatePreOrderButton();

        // Re-apply label after product-info.js re-renders the button on variant change
        subscribe(PUB_SUB_EVENTS.variantChange, ({ data: { variant } }) => {
          if (!variant) return;
          const matched = this.variants.find((v) => v.id == variant.id);
          this.currentVariant = matched || null;
          this.updatePreOrderButton();
        });
      }

    updatePreOrderButton() {
      // Don't override sold-out or otherwise disabled button state
      if (this.submitButton.hasAttribute('disabled')) return;
      
      const variantPreOrder = this.currentVariant?.metafields?.custom?.pre_order;
      const productPreOrder = window.productPreOrder || this.initialPreOrder;

      // Variant-level takes precedence; fall back to product-level only if no variants
      // have any pre_order set (i.e., this is a no-variant product)
      const hasAnyVariantPreOrder = this.variants.some((v) => v.metafields?.custom?.pre_order);
      const isPreOrder = hasAnyVariantPreOrder ? !!variantPreOrder : !!productPreOrder;

      this.dataset.preOrder = isPreOrder ? 'Y' : '';

      if (this.submitButtonText) {
        this.submitButtonText.textContent = isPreOrder
          ? 'Pre-Order'
          : window.variantStrings?.addToCart || 'Add to Cart';
      }

      // Update the pre-order info box
      const sectionEl = this.closest('[data-section]');
      const sectionId = sectionEl ? sectionEl.dataset.section : null;
      const infoBox = sectionId ? document.getElementById(`pre-order-info-${sectionId}`) : null;
      if (!infoBox) return;

      if (isPreOrder) {
        let caDate, generalDate;
        if (variantPreOrder) {
          caDate = this.currentVariant.metafields.custom.pre_order_ca_date;
          generalDate = this.currentVariant.metafields.custom.pre_order_general_date;
        } else {
          caDate = window.productPreOrderDates?.ca;
          generalDate = window.productPreOrderDates?.general;
        }

        const caWrap = infoBox.querySelector('.po-ca-date');
        const generalWrap = infoBox.querySelector('.po-general-date');
        const caRow = sectionId ? document.getElementById(`po-ca-date-wrap-${sectionId}`) : null;
        const generalRow = sectionId ? document.getElementById(`po-general-date-wrap-${sectionId}`) : null;

        if (caWrap) caWrap.textContent = caDate || '';
        if (generalWrap) generalWrap.textContent = generalDate || '';
        if (caRow) caRow.style.display = caDate ? '' : 'none';
        if (generalRow) generalRow.style.display = generalDate ? '' : 'none';

        infoBox.style.display = '';
      } else {
        infoBox.style.display = 'none';
      }
    }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure('add:paint-updated-sections', () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure('add:paint-updated-sections', () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent('add:user-action', evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          // Re-apply pre-order label instead of blindly resetting to addToCart
          this.updatePreOrderButton();
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}